import React from 'react'
import { useParams } from 'react-router-dom'
import aidyGif from '../assets/Aidy.gif'
import discoverPng from '../assets/discover1.png'
import zykrrLogoUpdatedPng from '../assets/zykrr-logo-updated.png'
import zykrrLogoPng from '../assets/zykrr-logo.png'

const ICONS: Record<string, string> = {
  'Aidy.gif': aidyGif,
  'discover1.png': discoverPng,
  'zykrr-logo-updated.png': zykrrLogoUpdatedPng,
  'zykrr-logo.png': zykrrLogoPng,
}

const Logo: React.FC = () => {
  const { iconName } = useParams<{ iconName: string }>()

  if (!iconName) {
    return <div>No icon provided</div>
  }

  // iconName comes from the URL, so only serve files from this fixed allowlist
  if (!Object.prototype.hasOwnProperty.call(ICONS, iconName)) {
    console.error('Image not found:', iconName)
    return <div>Image not found</div>
  }

  const iconSrc = ICONS[iconName]

  return (
    <div style={{ textAlign: 'center', padding: '2rem' }}>
      <img
        src={iconSrc}
        alt={iconName}
        style={{ maxWidth: '200px', height: 'auto' }}
      />
    </div>
  )
}

export default Logo
